import React from "react";

import {
  UnassignPropertyFromPortfolioModal,
  AssignPropertyToPortfolioModal,
} from "manager/components/Modal";
import AssignEmployeesToPropertyModal from "manager/components/Modal/AssignEmployeesToPropertyModal";
import { openCreateUnitWithSuccessModal } from "manager/components/Modal/CreateUnitModal";
import {
  invalidatePropertyListCaches,
  useTogglePropertyDisplayOnPortal,
  useTogglePropertyPrequalification,
} from "manager/hooks/api";
import { usePermissions } from "shared/hooks";
import useModal from "shared/hooks/useModal";

import {
  AssignEmployeesToPropertyParams,
  AssignPropertyToPortfolioParams,
  CreateUnitParams,
  PropertiesSearchParams,
  UnassignPropertyFromPortfolioParams,
} from "../interfaces";

import BillingPropertiesSections from "./BillingPropertiesSections";

interface BillingPropertiesSectionsContainerProps {
  hasInputValue: boolean;
  propertiesSearchParams: PropertiesSearchParams;
}

const BillingPropertiesSectionsContainer = ({
  hasInputValue,
  propertiesSearchParams,
}: BillingPropertiesSectionsContainerProps) => {
  const { openModalDialog } = useModal();
  const { togglePropertyDisplayOnPortal, isSavingDisplayOnPortal } =
    useTogglePropertyDisplayOnPortal();
  const { togglePropertyPrequalification, isSavingPrequalification } =
    useTogglePropertyPrequalification();
  const {
    isMagicPortalEnabled,
    isPrescreeningEnabled,
    canManagePrequalificationOnProperty,
  } = usePermissions();

  const createUnit = (context: CreateUnitParams) =>
    openCreateUnitWithSuccessModal(context);

  const assignEmployeesToProperty = (
    context: AssignEmployeesToPropertyParams
  ) => openModalDialog(AssignEmployeesToPropertyModal, context);

  const unassignPropertyFromPortfolio = (
    context: UnassignPropertyFromPortfolioParams
  ) => openModalDialog(UnassignPropertyFromPortfolioModal, context);

  const assignPropertyToPortfolio = (
    context: AssignPropertyToPortfolioParams
  ) => openModalDialog(AssignPropertyToPortfolioModal, context);

  return (
    <BillingPropertiesSections
      hasInputValue={hasInputValue}
      propertiesSearchParams={propertiesSearchParams}
      isMagicPortalEnabled={isMagicPortalEnabled}
      showPrequalificationCheckbox={
        isPrescreeningEnabled && canManagePrequalificationOnProperty
      }
      onTogglePropertyDisplayOnPortal={(propertyId) =>
        togglePropertyDisplayOnPortal(propertyId, {
          onSuccess: invalidatePropertyListCaches,
        })
      }
      onTogglePropertyPrequalification={(propertyId) =>
        togglePropertyPrequalification(propertyId, {
          onSuccess: invalidatePropertyListCaches,
        })
      }
      createUnit={createUnit}
      isSavingDisplayOnPortal={isSavingDisplayOnPortal}
      isSavingPrequalification={isSavingPrequalification}
      assignEmployeesToProperty={assignEmployeesToProperty}
      unassignPropertyFromPortfolio={unassignPropertyFromPortfolio}
      assignPropertyToPortfolio={assignPropertyToPortfolio}
    />
  );
};

export default BillingPropertiesSectionsContainer;
